export const SET_ADDTHIS_LOADED = '[ADDTHS] SET LOADED';

export function setAddThis({ isLoaded = false }) {
  return {
    type: SET_ADDTHIS_LOADED,
    isLoaded,
  };
}
